function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { defaultAnalyticsFunction, EventCategory, EventType, useAnalyticsContent } from '../analytics';
import { alertSendsAnalytics } from '../flags';
export default function useAlertAnalytics(_ref) {
  var analytics = _ref.analytics,
      analyticsLabelOverride = _ref.analyticsLabelOverride,
      _ref$onAnalyticsEvent = _ref.onAnalyticsEvent,
      onAnalyticsEvent = _ref$onAnalyticsEvent === void 0 ? defaultAnalyticsFunction : _ref$onAnalyticsEvent,
      variation = _ref.variation;

  // Order matters! Content comes from the heading first and falls back to body if heading doesn't exist
  var _useAnalyticsContent = useAnalyticsContent({
    componentName: 'Alert',
    onMount: function onMount(content) {
      if (analytics !== true && (!alertSendsAnalytics() || analytics === false)) {
        return;
      } // Do not send analytics event for default alerts


      // Do not send analytics event for default alerts
      if (!variation) {
        return;
      }

      var eventHeadingText = analyticsLabelOverride !== null && analyticsLabelOverride !== void 0 ? analyticsLabelOverride : content;

      if (!eventHeadingText) {
        console.error('No content found for Dialog analytics event');
        return;
      }

      onAnalyticsEvent({
        event_name: 'alert_impression',
        event_type: EventType.UI_INTERACTION,
        event_action: 'alert impression',
        event_category: EventCategory.UI_COMPONENTS,
        event_label: eventHeadingText,
        heading: eventHeadingText,
        type: variation
      });
    }
  }),
      _useAnalyticsContent2 = _slicedToArray(_useAnalyticsContent, 2),
      headingRef = _useAnalyticsContent2[0],
      bodyRef = _useAnalyticsContent2[1];

  return {
    headingRef: headingRef,
    bodyRef: bodyRef
  };
}